import axios from 'axios';
import { rbxAuthToken } from '../config';

export const addTokenToRequest = (acc) => {
  const token = localStorage.getItem(rbxAuthToken);

  if (token !== null) {
    acc.headers.Authorization = `Basic ${token}`;
  }

  return acc;
};

/* istanbul ignore next */
(() => {
  axios.interceptors.request.use(addTokenToRequest, err => Promise.reject(err));
})();

